// Base URL

// export const serverapi = "http://192.168.1.8:4748";
export const serverapi = "https://nodeapi.godigitalchat.com/Zadpi_Coins";

export const Api = {
    baseurl: serverapi,
    adminLogin: serverapi + "/adminlogin",

    addCustomer: serverapi + "/addcustomer",
    addCategory: serverapi + "/addcategory",
    addProduct: serverapi + "/addProduct",
    coinAllotment: serverapi + "/coinallotment",

    getCustomers: serverapi + "/getcustomers",
    getCategories: serverapi + "/getcategories",
    getProducts: serverapi + "/getproducts",
    getCoinAllot: serverapi + "/getcoinallot",

    editCustomer: serverapi + "/editcustomer",
    editCategory: serverapi + "/editcategory",
    editProducts: serverapi + "/editproduct",
    editCoinAllot: serverapi + "/editcoin",


    // USER API
    userLogin: serverapi + "/userlogin",
    verifyOtp: serverapi + "/verifyotp",
    resendOtp: serverapi + "/resendotp",

    getuserproduct: serverapi+ "/user/GetProduct",
    addReference: serverapi + "/user/AddReference",
    getReference: serverapi + "/user/GetReference",
    getTransaction: serverapi + "/user/GetTransactionHistory",
    getUserDashboard: serverapi + "/user/GetDashboard"
}

